// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cb9aa3d0","453":"7d55919d","455":"a3b64c8c","977":"f571ed0a"}[chunkId] + ".chunk.js";
};